import React from 'react'
import { RootObject,PartnersContent } from '../../type';
import './style.less';

const Partners = (props:RootObject["partners"]) => {
  return (
    <div className="partners">
      <div className="partners_title">
        {props.partnersTitle ?? ""}
      </div>
      <div className="partners_content">
      {
        props.partnersContent.map((value:PartnersContent,index:number)=>{
         
            return ( 
              <img src={value.partnerList} alt="" key={index}/>
              )
        
         
        })
      }
      </div>
    </div>
  )
}

export default Partners;